import { createLucideIcon } from "lucide-react";

export const DragDrop = createLucideIcon(
    "DragDrop",
    [
        [
            "path",
            {
                d: "M15.9937 12H16",
                key: "13zmt5",
            },
        ],
        [
            "path",
            {
                d: "M15.9937 18H16",
                key: "16co2l",
            },
        ],
        [
            "path",
            {
                d: "M15.9937 6H16",
                key: "i5fdfk",
            },
        ],
        [
            "path",
            {
                d: "M8 12H8.0064",
                key: "1uvg10",
            },
        ],
        [
            "path",
            {
                d: "M8 18H8.0064",
                key: "yb9bcq",
            },
        ],
        [
            "path",
            {
                d: "M8 6H8.0064",
                key: "41o7lx",
            },
        ],
    ],
);
